import React, { FC, ReactNode } from "react";
import { Box, Typography } from "@mui/material";
import "./PifSectionCard.scss";

interface PifSectionCardProps {
  id: string;
  title: string;
  note?: string;
  badge?: ReactNode;
  children: ReactNode;
}

const PifSectionCard: FC<PifSectionCardProps> = ({ id, title, note, badge, children }) => (
  <Box id={id} className="pif-section-card">
    <Box className="pif-section-card__header">
      <Box className="pif-section-card__title-row">
        <Typography className="pif-section-card__title">{title}</Typography>
        {badge}
      </Box>
      {note ? <Typography className="pif-section-card__note">{note}</Typography> : null}
    </Box>
    {children}
  </Box>
);

export default PifSectionCard;
